import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { SpinnerButton } from 'web_core/assets/spinners'
import { ShapedTimestamp } from 'web_core/assets/timestamp/ShapedTimestamp'
import { useAccount } from 'web_core/context/account'
import { Subscription } from 'web_core/firebase'
import { PromiseVoid } from 'web_core/types'
import styles from '~/styles/_pricing.module.scss'
import { PLANS, PlanCardType } from './PlanCard'

type Props = {
  openPortal: () => PromiseVoid
  opening: boolean
  planType: PlanCardType
  subscription: Subscription | null | undefined
  showChangePlanModal: () => PromiseVoid
  showSubscribePlanModal: () => PromiseVoid
  showLoginPopup: () => PromiseVoid
}

export const PlanCardActionButton = ({
  openPortal,
  opening,
  showSubscribePlanModal,
  showChangePlanModal,
  showLoginPopup,
  planType,
  subscription,
}: Props) => {
  const planInfo = PLANS[planType]
  const { account } = useAccount()

  if (account === undefined || subscription === undefined) {
    // accountとsubscriptionが読み込み中の時
    return (
      <Button
        className={`${styles['pricing-btn']} w-100 fs-6 mt-6`}
        disabled
        variant={planType === 'free' ? 'secondary' : 'primary'}
      >
        読み込み中...
      </Button>
    )
  } else if (account === null) {
    return (
      <Button
        className={`${styles['pricing-btn']} w-100 fs-6 mt-6`}
        onClick={showLoginPopup}
      >
        {planType === 'free' ? '無料で開始' : '1週間無料で体験'}
      </Button>
    )
  } else if (account.plan === 'Free') {
    // Freeプランのユーザの場合
    return planType === 'free' ? (
      <Button
        variant="secondary"
        className={`${styles['pricing-btn']} w-100 fs-6 mt-6`}
        disabled
      >
        利用中のプラン
      </Button>
    ) : (
      <Button
        className={`${styles['pricing-btn']} w-100 fs-6 mt-6`}
        onClick={showSubscribePlanModal}
      >
        {account.has_tried_premium_plan === true
          ? 'プランを開始'
          : '1週間無料で体験'}
      </Button>
    )
  } else if (
    account.plan === 'Premium' &&
    subscription?.cancel_at_period_end === false
  ) {
    // 契約済みのユーザで解約していない場合
    return planType === 'free' ? (
      <SpinnerButton
        className={`${styles['pricing-btn']} w-100 fs-6 mt-6`}
        onClick={openPortal}
        loading={opening}
        variant="secondary"
      >
        プランを変更
      </SpinnerButton>
    ) : account.plan_interval === planInfo.interval ? (
      <Button className={`${styles['pricing-btn']} w-100 fs-6 mt-6`} disabled>
        利用中のプラン
      </Button>
    ) : (
      <Button
        className={`${styles['pricing-btn']} w-100 fs-6 mt-6`}
        onClick={showChangePlanModal}
      >
        プランを変更
      </Button>
    )
  } else if (
    account.plan === 'Premium' &&
    subscription?.cancel_at_period_end === true
  ) {
    // 契約済みのユーザで解約の手続きをされている場合
    return planType === 'free' ? (
      <Button
        className={`${styles['pricing-btn']} w-100 fs-6 mt-6`}
        disabled
        variant="secondary"
      >
        利用中のプラン
      </Button>
    ) : account.plan_interval === planInfo.interval ? (
      <>
        <SpinnerButton
          className={`${styles['pricing-btn']} w-100 fs-6 mt-6`}
          loading={opening}
          onClick={openPortal}
        >
          プランを再開
        </SpinnerButton>
        <p className="text-muted small mt-2 mb-0">
          <ShapedTimestamp
            timestamp={subscription.current_period_end}
            absolute
          />
          まで使えます
        </p>
      </>
    ) : (
      <OverlayTrigger
        placement={'top'}
        overlay={
          <Tooltip>プランを変更する前にプランを再開してください。</Tooltip>
        }
      >
        <Button
          className={`${styles['pricing-btn']} w-100 fs-6 mt-6`}
          variant="secondary"
        >
          プランを変更
        </Button>
      </OverlayTrigger>
    )
  } else if (account.plan === 'Premium' && subscription === null) {
    return (
      <SpinnerButton
        className={`${styles['pricing-btn']} w-100 fs-6 mt-6`}
        loading={true}
        loadingText="お手続き中..."
      >
        お手続き中...
      </SpinnerButton>
    )
  } else {
    throw new Error('Unreachable')
  }
}
